import { ECookie } from './useCookies.enums';

const cookiesData = [
	{
		id: `essential-cookies-switch`,
		dataCy: `essential-cookies-switch`,
		isDisabled: true,
		defaultValue: true,
		label: 'Essential cookies',
		loreDescription: `These warding runes are essential to maintaining the fabric that keeps our portals running. They may never be broken, or the portals might unravel.`,
		legalDescription: 'These cookies are essential and can not be turned off.',
		type: ECookie.essentials
	},
	{
		id: `sentry-cookies-switch`,
		dataCy: `sentry-cookies-switch`,
		label: 'Sentry: Error and Performance Monitoring',
		loreDescription: `Grant us leave to summon tireless watchers that can detect glitches in the weave, safeguarding our portal's resilience and efficacy, thus ensuring smooth questing for all Guardians.`,
		legalDescription: `Allow us to monitor website performance and identify any errors to improve the stability and functionality of our platform.`,
		type: ECookie.sentry
	},
	{
		id: `mouseflow-cookies-switch`,
		dataCy: `mouseflow-cookies-switch`,
		label: 'Mouseflow',
		loreDescription: `Give us the power to cast potent spells that can unveil the echoes of your strides as you travel through the realm, allowing us to craft a better experience, truly befitting of your magical prowess.`,
		legalDescription: `Enable tracking of your interactions on our website to help us analyze and optimize our platform for a better user experience.`,
		type: ECookie.mouseflow
	},
	{
		id: `analytics-cookies-switch`,
		dataCy: `analytics-cookies-switch`,
		label: 'Google analytics',
		loreDescription: `Allow us to cast arcane spells to decipher the enigmatic traces of your passage through our portals, so we may fortify the path for those who follow.`,
		legalDescription: `Allow us to collect anonymous data about your visit to help us improve our website's user experience.`,
		type: ECookie.analytics
	}
];

export { cookiesData };
